import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextWithIcon from '../../../../components/Input/TextWithIcon';
import formSectionWrapper from '../components/FormSectionWrapper'
import AssignmentIndOutlined from '@material-ui/icons/AssignmentIndOutlined'
const mapStateToProps = (state) => {
    return {
        lastModifiedBy: state.changelogForm.lastModifiedBy,
    }
}
class ChangelogLastModifiedByContainer extends Component {
    render() {
        return (
            <div style={{position: 'relative', paddingTop: 20}}>
                <TextWithIcon label="Last modified by" value={this.props.lastModifiedBy} icon={AssignmentIndOutlined}/>
            </div>
        )
    }
}
export default formSectionWrapper(connect(mapStateToProps, null)(ChangelogLastModifiedByContainer));